import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { SecureLayoutComponent } from './secure-layout/secure-layout.component';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { HeaderComponent } from './header/header.component';
// import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import {TranslateModule} from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangelogComponent } from './changelog/changelog.component';



@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    TranslateModule,
    NgbModule,
    
  ],
  exports: [
    CustomLayoutComponent,
    SecureLayoutComponent,
    PublicLayoutComponent
  ],
  declarations: [    
  CustomLayoutComponent,    
  SecureLayoutComponent,    
  PublicLayoutComponent,
  HeaderComponent,
  ChangelogComponent
  
]
})
export class LayoutModule { }